import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CategoryTileComponent } from '../category-tile/category-tile.component';
import { CategoryContextDirective } from 'ish-core/directives/category-context.directive';

@Component({
  selector: 'ish-category-list',
  templateUrl: './category-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CategoryTileComponent,CategoryContextDirective],
})
export class CategoryListComponent {
  readonly categories = input.required<string[]>();
}
